import * as React from "react";
import { Formik, Form, FormikProps, FormikActions } from "formik";
import "../Style/StandardForm.scss";
import FormFields from "./FormFields";
import FormButton from "./FormButton";
import FormCheckOutComponent from "./FormCheckOutComponent";
import Modal from "./Modal";
import { removeWhiteSpaces, createGenericValidationSchema } from "./FunctionLib";
import { IStandardFormProps, FormConstants, EventFormFields } from "./Constants";
import { separateCustomFormFields } from "./StandardForm";
import { EventRegFormModel } from "../../ml_modules/websiteApi/EventRegFormModel";
import ErrorMessage from "./ErrorMessage";
import { injectStripe } from 'react-stripe-elements';
import { message, ICampaign } from "../../DonateForm/Components/DonateForm";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { getRcTokenAsync, IRcTokenResponse } from "../../GoogleReCaptcha/Recaptcha";
import { isNullOrWhiteSpace, isEmpty } from "../../../common/helper/helper";
import { useEffect, useState } from "react";

const initialValues: IInitialValues = {
    [FormConstants.firstName]: "",
    [FormConstants.lastName]: "",
    [FormConstants.email]: "",
    [FormConstants.postcode]: "",
    [FormConstants.numberOfTickets]: 1,
    Amount: 0,
};

interface IInitialValues {
    [x: string]: any
}

const useComponentDidMount = (func) => useEffect(func, []);

const getPaymentRecipient = (defaultPaymentDestination: string, contentId: string, setPaymentRecipient: React.Dispatch<React.SetStateAction<IPaymentRecipient>>) => {
    try {
        fetch(`/Umbraco/Api/FinanceService/GetCampaignList?contentId=${contentId}`,
            { method: "GET" })
            .then(resp => resp.json())
            .then((data) => {
                if (!isEmpty(data) && data.data != undefined && !isEmpty(data.data)) {
                    const campaignList = data.data as ICampaign[]
                    if (defaultPaymentDestination && campaignList.find((c) => c.website_name.trim() == defaultPaymentDestination)) {
                        setPaymentRecipient({
                            account: campaignList.find((c) => c.website_name.trim() == defaultPaymentDestination).account,
                            campaignCode: campaignList.find((c) => c.website_name.trim() == defaultPaymentDestination).code
                        });
                    }
                }
            }
            )
    } catch (e) {
        alert(`Fail to match campaign name.`)
    }
}

interface IEventFormProps extends IStandardFormProps {
    defaultPaymentDestination?: string
    setIsSubmitted: React.Dispatch<React.SetStateAction<boolean>>
}

interface IPaymentRecipient {
    account: string
    campaignCode: string
}

export const EventForm = (props: IEventFormProps) => {
    const [paymentRecipient, setPaymentRecipient] = useState<IPaymentRecipient>({ account: "", campaignCode: "" });
    useComponentDidMount(() => getPaymentRecipient(props.defaultPaymentDestination, props.contentId, setPaymentRecipient))
    const { executeRecaptcha } = useGoogleReCaptcha()
    const handleResponse = async (resp: any, actions: FormikActions<any>, setIsSubmitted: React.Dispatch<React.SetStateAction<boolean>>) => {
        const jsonRes = await resp.json();
        if (jsonRes.Success === false || !resp.ok) {
            setSubmitError(`${jsonRes.Message !== undefined ? jsonRes.Message : ''} ${resp !== undefined && !resp.ok ? jsonRes : ''}`);
            actions.setSubmitting(false);
        } else {
            setSubmitDisabled(true);
            setIsSubmitted(true);
            actions.resetForm();
            if (!isNullOrWhiteSpace(props.redirectUrl) && props.modalEnabled === false) {
                if (props.redirectTarget == "_blank") {
                    window.open(props.redirectUrl, props.redirectTarget)
                } else {
                    window.location.href = props.redirectUrl;
                }
            } else {
                if (props.modalEnabled) {
                    setShowModal(true);
                }
                setSubmitError("Your form has been successfully submitted. Thank you.");
            }
        }
    }


    let submitFunction = async (values: EventRegFormModel, actions: FormikActions<EventRegFormModel>, paymentRecipient: IPaymentRecipient, setIsSubmitted: React.Dispatch<React.SetStateAction<boolean>>) => {
        const rcToken = getRcTokenAsync("eventReg", executeRecaptcha);
        const fixedValues = separateCustomFormFields(values, EventFormFields, props.fields);
        fixedValues["eventId"] = props.eventId;
        if (values[FormConstants.numberOfTickets] === 0 && props.maximumTicketsPerReg < 2) {
            fixedValues[FormConstants.numberOfTickets] = 1;
        }
        const ContentId = parseInt(props.contentId, 10);
        let body = { ContentId: ContentId, ...fixedValues };

        if (props.paymentRequired) {
            if (generateTokenRef.current) {
                body = await generateTokenRef.current(ContentId, fixedValues, actions, paymentRecipient.account, rcToken);
            } else {
                setSubmitError(message.tokenError);
                actions.setSubmitting(false);
            }
        }

        if (!props.paymentRequired || (props.paymentRequired && !body === false)) {
            await fetch("/Umbraco/Api/EventRegForm/Submit", {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ ...body, Campaign: paymentRecipient.campaignCode })
            })
                .then(resp => {
                    handleResponse(resp, actions, setIsSubmitted);
                });
        } else {
            setSubmitError(message.tokenError);
            actions.setSubmitting(false);
        }
    };
    const [hasSubmit, setHasSubmit] = React.useState<boolean>(false)
    const [submitError, setSubmitError] = React.useState("");
    const [showModal, setShowModal] = React.useState(false);
    const [stripeError, setStripeError] = React.useState("");
    const [stripeComplete, setStripeComplete] = React.useState(false);
    const [submitDisabled, setSubmitDisabled] = React.useState(false);

    const generateTokenRef = React.useRef<(
        contentId: number,
        fixedValues: any,
        actions: FormikActions<any>,
        account: string,
        recaptChaToken: Promise<IRcTokenResponse>) => void>();

    const updateTokenGenerator = (func: () => Promise<any>) => {
        generateTokenRef.current = func;
    }

    // what is this? ahh so props.fields are the custom fields that may be specified
    // here we are adding in something to the initial values
    // this does this only once
    const [formikInitial] = React.useState(() => {
        const initial = { ...initialValues };
        Object.entries(props.fields).forEach(([key, value]) => {
            if (value.CustomFieldType == 'checkbox') {
                initial[removeWhiteSpaces(value.Name)] = false;
            } else {
                initial[removeWhiteSpaces(value.Name)] = "";
            }
        });
        if (props.commonFieldsMeta.State.Required) {
            initial[FormConstants.state] = "";
        }
        return initial
    });

    return <div className="genWrapper">
        <Formik
            initialValues={formikInitial}
            validationSchema={createGenericValidationSchema(props.commonFieldsMeta, props.fields)}
            onSubmit={(values: EventRegFormModel, actions: FormikActions<EventRegFormModel>) => submitFunction(values, actions, paymentRecipient, props.setIsSubmitted)}
            render={({ errors, touched, values, setFieldValue, isSubmitting }: FormikProps<any>) => {
                return <Form hidden={props.totalTickets > 0 && props.ticketsLeft < 1}>
                    <Modal
                        showModal={showModal}
                        setShowModal={setShowModal}
                        shareUrl={props.shareUrl}
                        shareTitle={props.shareTitle}
                        shareMessage={props.shareMessage}
                        shareHashTag={props.shareHashTag}
                        modalTitle={props.modalTitle}
                        modalMessage={props.modalMessage}
                        colorTheme={props.colorTheme}
                        modalImageUrl={props.modalImageUrl}
                    />
                    <div className="eventForm">
                        <div className="contentWrapper">
                            <div className={`${props.disableGradient ? '' : 'genGradient'} ` + props.colorTheme}>
                                <div className="container">
                                    {props.formHeader ? <p className="event-form-header">{props.formHeader}</p> : null}
                                    {props.headerSubtext ? <p className="event-form-subheader">{props.headerSubtext}</p> : null}
                                    <hr />
                                    <FormFields
                                        errors={errors}
                                        values={values}
                                        touched={touched}
                                        setFieldValue={setFieldValue}
                                        colorTheme={props.colorTheme}
                                        fields={props.fields}
                                        isColumn={props.fieldsAsColumn || props.narrowForm}
                                        commonFieldsMeta={props.commonFieldsMeta}
                                    />
                                    <FormCheckOutComponent
                                        setFieldValue={setFieldValue}
                                        contentId={props.contentId}
                                        paymentProvider={props.paymentProvider}
                                        stripe={props.stripe}
                                        updateTokenGenerator={updateTokenGenerator}
                                        maximumTicketsPerReg={props.maximumTicketsPerReg}
                                        totalTickets={props.totalTickets}
                                        ticketsLeft={props.ticketsLeft}
                                        errors={errors}
                                        touched={touched}
                                        colorTheme={props.colorTheme}
                                        paymentRequired={props.paymentRequired}
                                        ticketCost={props.ticketCost}
                                        values={values}
                                        paymentError={stripeError}
                                        setPaymentError={setStripeError}
                                        setPaymentComplete={setStripeComplete}
                                        isColumn={props.fieldsAsColumn || props.narrowForm}
                                        isEventReg={true}
                                    />
                                </div>
                                {(hasSubmit && !submitDisabled) && <div className="genErrorMessages">
                                    {
                                        Object.keys(values).map((key: any, index: any) => touched[key] && errors[key] ? <ErrorMessage
                                            errors={errors}
                                            touched={touched}
                                            colorTheme={props.colorTheme}
                                            name={key}
                                            key={index}
                                        /> : null)
                                    }
                                </div>}
                                <div className="container">
                                    <FormButton
                                        colorTheme={props.colorTheme}
                                        errors={errors}
                                        touched={touched}
                                        buttonText={props.buttonText}
                                        buttonRoundedCorners={props.buttonRoundedCorners}
                                        isEventForm={true}
                                        buttonColorTheme={props.buttonColorTheme}
                                        setHasSubmit={setHasSubmit}
                                        submitDisabled={(props.maximumTicketsPerReg > 1 && values[FormConstants.numberOfTickets] === 0) ||
                                            (props.paymentRequired ?
                                                (stripeError !== "" || !stripeComplete) || (isSubmitting ? true : submitDisabled) :
                                                isSubmitting ? true : submitDisabled)}
                                    />
                                    {submitError ? (
                                        <div className="SubmitErrorMessage">
                                            {submitError}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            }}
        />
        {props.totalTickets === 0 || props.ticketsLeft > 0 ? (
        <></>
        ) : (
        <p>
            ** Registration is now closed as the event has reached full capacity. Thank you
            for your interest.**
        </p>
        )}
    </div>
}

export default injectStripe(EventForm);
